// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;




export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39')
];

export const server_loads = [3];

export const dictionary = {
		"/": [4],
		"/account": [~5],
		"/account/login": [~6],
		"/case-studies/bmw-x3-30e-fender-charging-cap": [7],
		"/case-studies/ram-1500-fender-flare": [8],
		"/compare/ppf-engine-vs-exactflat": [9],
		"/consent": [~10],
		"/demo-requested": [11],
		"/dev/hero-lab": [12,[2]],
		"/dev/morph-record": [14,[2]],
		"/dev/morph": [13,[2]],
		"/dev/ui": [15,[2]],
		"/faq": [16],
		"/guides/how-to-make-custom-ppf-patterns": [17],
		"/lab": [18,[3]],
		"/lab/blueprint": [19,[3]],
		"/lab/clips-job": [20,[3]],
		"/lab/clips-job/workflow": [21,[3]],
		"/lab/clips-rail": [22,[3]],
		"/lab/clips-rail/guide": [23,[3]],
		"/lab/clips-wall": [24,[3]],
		"/lab/clips-wall/tools": [25,[3]],
		"/lab/film": [26,[3]],
		"/lab/pitch": [27,[3]],
		"/lab/workbench-light": [29,[3]],
		"/lab/workbench": [28,[3]],
		"/legal/imprint": [30],
		"/legal/preorder": [31],
		"/legal/privacy": [32],
		"/legal/terms": [33],
		"/links": [34],
		"/ppf-pattern-software": [35],
		"/pricing": [36],
		"/technology/3d-scan-to-ppf-pattern": [37],
		"/technology/scanner-plotter-compatibility": [38],
		"/thanks": [~39]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);